/**
 * Payments by Case — CB's answer is one entry per case, each with its payments
 * nested (`{ name, client, billableId, payments: [{ reference, date, type, amount }] }`).
 * Legacy's Print view lists each case, then its payments (Views/PaymentsByCaseReport/
 * Print.cshtml:157-178), with the cases ordered by name (AccountingModels.cs:363).
 *
 * The grid takes one row per payment, carrying its case and client, so every amount
 * appears exactly once and the footer total is the sum of the payments listed. The
 * Group By control regroups the rows by case when wanted.
 *
 * `date` is CB's own formatted string (M/D/YYYY on a US tenant) and is shown as CB
 * wrote it: a client reformat could swap day and month on another culture
 * (src/utils/displayDate.js).
 */

// Legacy prints each payment as N2 (Print.cshtml:178).
const fmtAmount = (v) => {
  const n = Number(v)
  if (!Number.isFinite(n)) return ''
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export const PAYMENTS_BY_CASE_COLUMNS = [
  { key: 'case', label: 'Case' },
  { key: 'reference', label: 'Reference#' },
  { key: 'client', label: 'Client Name' },
  { key: 'date', label: 'Date' },
  { key: 'type', label: 'Type' },
  // `amount` reads as money to the grid's footer formatter (looksLikeMoneyKey).
  { key: 'amount', label: 'Payments', align: 'right', sum: true, render: (r) => fmtAmount(r.amount) },
]

/** CB's case sections → one row per payment, cases ordered by name as legacy orders them. */
export function flattenPaymentsByCase(sections) {
  if (!Array.isArray(sections)) return []
  const ordered = [...sections].sort((a, b) => String(a?.name ?? '').localeCompare(String(b?.name ?? '')))
  const rows = []
  for (const section of ordered) {
    for (const p of Array.isArray(section?.payments) ? section.payments : []) {
      rows.push({
        case: section.name ?? '',
        client: section.client ?? '',
        reference: p?.reference ?? '',
        date: p?.date ?? '',
        type: p?.type ?? '',
        amount: Number(p?.amount ?? 0),
      })
    }
  }
  return rows
}
